import styled from 'styled-components';

/**
 * The overlapping discs, Messenger style. Each one after the first tucks under
 * its left neighbour by a third of its width, and the white ring is what keeps
 * two red discs from merging into one blob where they overlap.
 */
export const BubbleStack = styled.div`
  display: flex;
  align-items: center;

  > * + * {
    margin-left: -8px;
  }

  > * {
    border-radius: 50%;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.white};
  }
`;

/**
 * The "+42" at the end of the stack: grey rather than red, so it reads as a
 * count of people not shown and not as one more person called "+4".
 */
export const MoreBubble = styled.div<{ $size: number }>`
  flex: none;
  min-width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  padding: 0 6px;
  border-radius: ${({ $size }) => $size / 2}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.gray};
  color: ${({ theme }) => theme.darkGray};
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
`;
